import React, { useCallback, useState } from 'react';
import { View, ScrollView } from 'react-native';
import PropTypes, {
  node,
  bool,
  number,
  func,
  string,
} from 'prop-types';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';

const ModalBox = ({
  children,
  scrollable,
  padding,
  alwaysShowBorder,
  scrollRef,
  onLayout,
  renderFooter,
  topBorderColor,
  color,
  testID,
  disabled,
  ...restProps
}) => {
  const containerProps = {
    padding,
    justifyContent: scrollable ? 'center' : 'space-evenly',
    alignItems: 'stretch',
    ...restProps,
  };

  const [atTop, setAtTop] = useState(true);
  const handleScroll = useCallback(e => {
    setAtTop(e.nativeEvent.contentOffset.y === 0);
  }, []);
  return (
    <Box
      flex={1}
      {...(scrollable ? {} : containerProps)}
      onLayout={onLayout}
      color={color}
      testID={testID}
      pointerEvents={disabled ? 'none' : 'auto'}
    >
      <View
        style={{
          borderStyle: 'solid',
          borderBottomWidth: atTop && !alwaysShowBorder ? 0 : 1,
          borderColor: topBorderColor,
        }}
      />
      {scrollable ? (
        <ScrollView
          scrollEventThrottle={1}
          onScroll={handleScroll}
          contentContainerStyle={containerProps}
          ref={scrollRef}
          testID="modal-box-scroll-view"
        >
          {children}
        </ScrollView>
      ) : (
        children
      )}
      {renderFooter?.()}
    </Box>
  );
};

ModalBox.propTypes = {
  children: node,
  scrollable: bool,
  padding: number,
  alwaysShowBorder: bool,
  onLayout: func,
  scrollRef: PropTypes.object,
  renderFooter: func,
  topBorderColor: string,
  color: string,
  testID: string,
  disabled: bool,
};

ModalBox.defaultProps = {
  renderFooter: null,
  children: null,
  scrollable: false,
  padding: 16,
  alwaysShowBorder: false,
  scrollRef: null,
  onLayout: null,
  topBorderColor: BrandColor.LightGrey,
  color: undefined,
  testID: undefined,
  disabled: false,
};

export default ModalBox;
